const TR_MAP = { ç: "c", ğ: "g", ı: "i", ö: "o", ş: "s", ü: "u", â: "a", î: "i", û: "u", Ç: "c", Ğ: "g", İ: "i", Ö: "o", Ş: "s", Ü: "u" };

export const slugify = (s = "") =>
  s.replace(/[çğıöşüâîûÇĞİÖŞÜ]/g, (c) => TR_MAP[c]).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80);

export const tr = (obj, lang = "tr") => {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.tr || "";
};

export const stripHtml = (h = "") => h.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();

export const SEG = {
  tr: { news: "yazilar", videos: "videolar", gallery: "galeri", contact: "iletisim", watch: "izle" },
  en: { news: "articles", videos: "videos", gallery: "gallery", contact: "contact", watch: "watch" },
};

export const href = (lang, key, slug) => {
  const pre = lang === "tr" ? "" : `/${lang}`;
  if (key === "home") return pre || "/";
  if (key === "page") return `${pre}/${slug}`;
  if (key === "news_category") return `${pre}/${SEG[lang].news}?kategori=${slug}`;
  if (key === "video_category") return `${pre}/${SEG[lang].videos}?kategori=${slug}`;
  if (key === "album") return `${pre}/${SEG[lang].videos}/${slug}`;
  if (key === "video") return `${pre}/${SEG[lang].videos}/${SEG[lang].watch}/${slug}`;
  const seg = SEG[lang][key];
  return slug ? `${pre}/${seg}/${slug}` : `${pre}/${seg}`;
};

export const menuHref = (m, lang) => {
  if (m.kind === "external") return m.url;
  if (m.kind === "internal") return lang === "tr" ? m.url : `/${lang}${m.url?.startsWith("/") ? m.url : `/${m.url}`}`;
  if (m.kind === "builtin") return href(lang, m.url || "home");
  if (m.kind === "none" || !m.kind) return null;
  return href(lang, m.kind === "page" ? "page" : m.kind, m.slug);
};

export const switchLangPath = (path, from, to) => {
  let p = from === "tr" ? path : path.replace(new RegExp(`^/${from}`), "") || "/";
  const segs = p.split("/");
  const rev = Object.fromEntries(Object.entries(SEG[from]).map(([k, v]) => [v, k]));
  if (segs[1] && rev[segs[1]]) segs[1] = SEG[to][rev[segs[1]]];
  p = segs.join("/") || "/";
  return to === "tr" ? p : `/${to}${p === "/" ? "" : p}`;
};

export const fmtDate = (iso, lang) => {
  try { return new Date(iso).toLocaleDateString(lang === "tr" ? "tr-TR" : "en-GB", { day: "numeric", month: "long", year: "numeric" }); }
  catch { return ""; }
};

export const UI = {
  tr: {
    contact: "İletişim", volunteer: "Gönüllü Ol", news: "Yazılar", videos: "Video Galerisi", gallery: "Resim Galerisi",
    latestNews: "Son Yazılar", allNews: "Tüm yazılar", featuredVideos: "Öne Çıkan Videolar", allVideos: "Tüm videolar",
    whoAmI: "Ben Kimim", readMore: "Devamını oku", search: "Yazılarda ara…", all: "Tümü", share: "Paylaş",
    related: "Diğer Yazılar", videosCount: "video", photos: "fotoğraf", notFound: "Aradığınız sayfa bulunamadı",
    backHome: "Anasayfaya dön", name: "Ad Soyad", email: "E-posta", phone: "Telefon (isteğe bağlı)", message: "Mesajınız",
    district: "İlçe", area: "Gönüllülük alanı", send: "Gönder", sending: "Gönderiliyor…", kvkk: "KVKK aydınlatma metnini okudum, onaylıyorum.",
    sent: "Teşekkürler! Mesajınız ulaştı.", whyRunning: "Neden Aday Oldum", priorities: "Önceliklerim", countdown: "Seçime Kalan",
    days: "Gün", hours: "Saat", minutes: "Dakika", seconds: "Saniye", joinUs: "Bu yolculukta yanımda olun",
    volunteerText: "Gönüllü ekibimize katılın; sahada, dijitalde ya da organizasyonda birlikte çalışalım.",
    reachMe: "Bana Ulaşın", reachText: "Görüş, öneri ve davetleriniz için yazın; size mutlaka dönüş yapacağım.",
    follow: "Beni takip edin", noResults: "Sonuç bulunamadı", prev: "Önceki", next: "Sonraki", menu: "Menü",
    rights: "Tüm hakları saklıdır.", minRead: "dk okuma", discover: "Beni tanıyın", contactInfo: "İletişim Bilgileri", office: "Ofis",
  },
  en: {
    contact: "Contact", volunteer: "Volunteer", news: "Articles", videos: "Video Gallery", gallery: "Photo Gallery",
    latestNews: "Latest Articles", allNews: "All articles", featuredVideos: "Featured Videos", allVideos: "All videos",
    whoAmI: "Who Am I", readMore: "Read more", search: "Search articles…", all: "All", share: "Share",
    related: "More Articles", videosCount: "videos", photos: "photos", notFound: "The page you are looking for was not found",
    backHome: "Back to home", name: "Full name", email: "Email", phone: "Phone (optional)", message: "Your message",
    district: "District", area: "Volunteering area", send: "Send", sending: "Sending…", kvkk: "I have read and accept the privacy notice (KVKK).",
    sent: "Thank you! Your message has been received.", whyRunning: "Why I'm Running", priorities: "My Priorities", countdown: "Until Election Day",
    days: "Days", hours: "Hours", minutes: "Minutes", seconds: "Seconds", joinUs: "Join me on this journey",
    volunteerText: "Join our volunteer team; let's work together in the field, online or in organisation.",
    reachMe: "Get in Touch", reachText: "Write to me with your views, suggestions and invitations; I will get back to you.",
    follow: "Follow me", noResults: "No results found", prev: "Previous", next: "Next", menu: "Menu",
    rights: "All rights reserved.", minRead: "min read", discover: "Get to know me", contactInfo: "Contact Information", office: "Office",
  },
};
